module.exports = __webpack_public_path__ + "img/doiim.b638615a.png";